import { useState } from "react";

const useLocalStorage = <T>(
    key: string,
    initialValue: T
): {
    storedValue: T;
    setValue: (value: T) => void;
    getValue: () => T | null;
} => {
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === "undefined") {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? (JSON.parse(item) as T) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const setValue = (value: T) => {
        try {
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== "undefined") {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getValue = (): T | null => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? (JSON.parse(item) as T) : null;
        } catch (error) {
            console.error("Error getting value from local storage", error);
            return null;
        }
    };

    return { storedValue, setValue, getValue };
};

export default useLocalStorage;
